import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Crown, Trash, Flag, CaretRight, Phone } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function PremiumCustomers() {
  const [vips, setVips] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchVIPs();
  }, []);

  const fetchVIPs = async () => {
    try {
      const response = await axios.get(`${API}/admin/customers/vip`);
      setVips(response.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveVIP = async (id) => {
    try {
      await axios.post(`${API}/admin/customers/${id}/toggle-vip`, { vip: false });
      toast.success('VIP status removed');
      fetchVIPs();
    } catch (err) {
      toast.error('Failed to update status');
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm">
      <div className="flex items-center gap-3 mb-6 border-b pb-3">
        <Crown size={28} className="text-yellow-500" />
        <div>
          <h2 className="text-xl font-bold text-gray-800">Premium Customers (VIP)</h2>
          <p className="text-sm text-gray-500">Manage VIP clients and custom routing configurations</p>
        </div>
      </div>

      {loading ? (
        <p className="text-gray-500 text-center py-6">Loading VIP list...</p>
      ) : vips.length === 0 ? (
        <p className="text-gray-400 text-center py-8">No VIP customers listed</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {vips.map((v) => {
            const initial = (v.username || v.phone || '?').charAt(0).toUpperCase();
            return (
              <div 
                key={v.id} 
                onClick={() => {
                  if (v.room_id) navigate(`/admin-chat/${v.room_id}`);
                }}
                className="flex items-center justify-between p-3 border border-gray-200 border-l-4 border-l-green-600 rounded-lg hover:bg-gray-50 bg-white transition-colors cursor-pointer shadow-sm"
              >
                <div className="flex items-center gap-3 overflow-hidden">
                  <div className="w-9 h-9 rounded-full bg-[#36A055] text-white flex items-center justify-center font-bold text-sm flex-shrink-0">
                    {initial}
                  </div>
                  <div className="overflow-hidden">
                    <h3 className="font-bold text-[13px] text-gray-800 truncate leading-tight mb-0.5">
                      {v.username || v.phone}
                    </h3>
                    <p className="text-[11px] text-gray-500 flex items-center gap-1">
                      <span>{v.mb_setup || ''} - - - </span>
                      <Phone size={12} weight="fill" className="text-pink-600 flex-shrink-0" />
                      <span className="truncate">{v.phone || 'N/A'}</span>
                    </p>
                  </div>
                </div>
                <div className="flex-shrink-0 ml-2">
                  <CaretRight size={16} className="text-gray-400" />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
